var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "preact/jsx-runtime";
import { useEffect, useRef, useState, useCallback } from 'preact/hooks';
import Player from '@vimeo/player';
const LightboxVimeoPlayer = ({ url }) => {
    const iFrameRef = useRef(null);
    const playerRef = useRef(null);
    const [normalizedUrl, setNormalizedUrl] = useState('');
    const [aspectRatio, setAspectRatio] = useState('16/9');
    const extractVimeoUrl = (url) => {
        const pattern = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)(?:\/(\w+))?/;
        const match = url.match(pattern);
        if (match) {
            const videoId = match[1];
            const hash = match[2];
            return hash
                ? `https://player.vimeo.com/video/${videoId}?h=${hash}&autoplay=1&muted=1`
                : `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1`;
        }
        return null;
    };
    const fetchVimeoVideoData = useCallback((videoId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`);
            const data = yield response.json();
            const ratio = `${data.width}/${data.height}`;
            setAspectRatio(ratio);
        }
        catch (error) {
            console.error('Error fetching Vimeo video data:', error);
        }
    }), []);
    const onVideoPlay = useCallback(() => {
        var _a;
        (_a = iFrameRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('ready');
    }, []);
    useEffect(() => {
        const normalizedUrl = extractVimeoUrl(url);
        if (!normalizedUrl)
            return;
        setNormalizedUrl(normalizedUrl);
        // Extract video ID from URL
        const videoIdMatch = url.match(/(?:vimeo\.com\/)(\d+)/);
        if (videoIdMatch) {
            fetchVimeoVideoData(videoIdMatch[1]);
        }
    }, [url, fetchVimeoVideoData]);
    useEffect(() => {
        if (!iFrameRef.current || !normalizedUrl)
            return;
        playerRef.current = new Player(iFrameRef.current, {
            autoplay: true,
        });
        playerRef.current.on('play', onVideoPlay);
        return () => {
            if (playerRef.current) {
                playerRef.current.off('play', onVideoPlay);
                playerRef.current.destroy();
            }
        };
    }, [normalizedUrl, onVideoPlay]);
    return (_jsx("iframe", { ref: iFrameRef, allow: "autoplay; fullscreen", allowFullScreen: true, src: normalizedUrl, style: {
            aspectRatio: aspectRatio,
            width: '100%',
            height: 'auto',
        } }));
};
export default LightboxVimeoPlayer;
